import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { scriptsApi } from '../api/client'

export function useScriptHistory(instanceId: string) {
  return useQuery({
    queryKey: ['scripts', instanceId],
    queryFn: () => scriptsApi.list(instanceId),
    enabled: !!instanceId,
  })
}

export function useScriptRun(instanceId: string, runId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['script-run', instanceId, runId],
    queryFn: () => scriptsApi.get(instanceId, runId),
    enabled: enabled && !!instanceId && !!runId,
    refetchInterval: (query) => {
      const run = query.state.data
      if (!run) return false
      return run.status === 'pending' || run.status === 'running' ? 2000 : false
    },
  })
}

export function useRunScript(instanceId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ script, backupFirst }: { script: string; backupFirst: boolean }) =>
      scriptsApi.run(instanceId, script, backupFirst),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['scripts', instanceId] }),
  })
}
